export function centsToDecimal(num) {
  return parseFloat(num / 100);
}

export function decimalToCents(num) {
  return parseInt(num * 100);
}